/**
 * Returns an empty object.
 *
 * @returns {Object} An empty object.
 * @example
 * stubObject() // Returns {}
 */
export function stubObject(): any {
  return {};
}
